import React, { useState, useEffect, useContext } from 'react'
import { useQueryClient } from 'react-query'
import { useLocation, useParams } from 'react-router-dom'

import { useGetAccounts } from '../api/accounts'
import { useAuth } from './UserAuthContext'

export const AccountsContext = React.createContext({
  accounts: {},
  accountParams: {},
  setAccountParams: () => {},
})

export function AccountsProvider({ children }) {
  const queryClient = useQueryClient()
  const { user } = useAuth()
  const [accountParams, setAccountParams] = useState({})
  const accounts = useGetAccounts(accountParams, { enabled: false })

  useEffect(() => {
    if (!accounts.data && !accounts.isFetching && user && accountParams?.htgCompany) {
      accounts.refetch()
    }
  }, [user, accounts, accountParams])

  useEffect(() => {
    if (!user) {
      setAccountParams({})
      queryClient.removeQueries(['accounts', 'list'])
    }
  }, [user, queryClient])

  return (
    <AccountsContext.Provider
      value={{
        accounts,
        accountParams,
        setAccountParams,
      }}
    >
      {children}
    </AccountsContext.Provider>
  )
}

export function useAccounts() {
  return useContext(AccountsContext)
}
